import React from "react";
import { Highlight } from "./chatHighlighterTypes";
import styles from "./chatHighlight.css";
import { assertUnreachable } from "@fidget/common/utils/ts-utils";

interface Props extends Highlight {}

export const ChatHighlight = ({ type, text }: Props) => {
  const renderHighlight = () => {
    switch (type) {
      case "MENTION":
        return <span className={styles.mention}>{text}</span>;
      case "PROFANITY":
        return <span className={styles.profanity}>{text}</span>;
      default: {
        assertUnreachable(type);
        return <span>{text}</span>;
      }
    }
  };

  return renderHighlight();
};
